import { Keypair } from '@solana/web3.js';
import { EmbeddedWallet } from './Wallet';
import idl_ from './dialect.json';
import programs_ from './programs.json';
import { ecdhDecrypt, ecdhEncrypt } from './ecdh-encryption';
export const idl = idl_;
export const programs = programs_;
export const display = (publicKey) => {
    const s = publicKey.toString();
    return `${s.slice(0, 4)}...${s.slice(s.length - 4)}`;
};
export const getPublicKey = (wallet, abbreviate = false) => {
    var _a;
    // if (!wallet || !wallet.connected) return null;
    if (!wallet)
        return null;
    const pubkeyStr = `${(_a = wallet === null || wallet === void 0 ? void 0 : wallet.publicKey) === null || _a === void 0 ? void 0 : _a.toBase58()}`;
    if (!abbreviate)
        return pubkeyStr;
    return (`${pubkeyStr === null || pubkeyStr === void 0 ? void 0 : pubkeyStr.slice(0, 4)}...${pubkeyStr === null || pubkeyStr === void 0 ? void 0 : pubkeyStr.slice((pubkeyStr === null || pubkeyStr === void 0 ? void 0 : pubkeyStr.length) - 4)}` ||
        null);
};
export class Wallet_ extends EmbeddedWallet {
    // anchor needs a non-optional publicKey attribute, sollet says it's optional, so we need to fix it here.
    get publicKey() {
        const pkornull = super.publicKey;
        let pk;
        if (!pkornull) {
            const kp = Keypair.generate();
            pk = kp.publicKey;
        }
        else {
            pk = pkornull;
        }
        return pk;
    }
}
export function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
/*
Transactions
*/
export async function waitForFinality(program, transactionStr, finality = 'confirmed', maxRetries = 10, // try 10 times
sleepDuration = 500) {
    try {
        return await waitForFinality_inner(program, transactionStr, finality, maxRetries, sleepDuration);
    }
    catch (e) {
        console.error(e);
        throw e;
    }
}
async function waitForFinality_inner(program, transactionStr, finality = 'confirmed', maxRetries = 10, // try 10 times
sleepDuration = 500) {
    let transaction = null;
    for (let n = 0; n < maxRetries; n++) {
        transaction = await program.provider.connection.getTransaction(transactionStr, { commitment: finality });
        if (transaction) {
            break;
        }
        await sleep(sleepDuration);
    }
    if (!transaction) {
        throw new Error('Transaction failed to finalize');
    }
    return transaction;
}
// TODO: instead use separate diffie-helman key with public key signed by the RSA private key.
export function encryptMessage(msg, sAccount, rPublicKey, nonce) {
    return ecdhEncrypt(msg, {
        publicKey: sAccount.publicKey.toBytes(),
        secretKey: sAccount.secretKey,
    }, rPublicKey.toBytes(), nonce);
}
export function decryptMessage(msg, account, fromPk, nonce) {
    return ecdhDecrypt(msg, {
        publicKey: account.publicKey.toBytes(),
        secretKey: account.secretKey,
    }, fromPk.toBytes(), nonce);
}
//# sourceMappingURL=index.js.map